export default __webpack_public_path__ + "static/media/ahmad.c018969a.jpg";